export const GET_UNSUBSCRIBE_REASONS =
  'unsubscribe-reasons/GET_UNSUBSCRIBE_REASONS';
